import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import DestopIcon from "material-ui/svg-icons/hardware/desktop-mac";
import MobileIcon from "material-ui/svg-icons/communication/stay-primary-portrait";
import FlatButton from "material-ui/FlatButton";
import { Flex, Box } from "rebass";

import StaticPage from "./editorPreview";
import bottomphone from "./img/phone-bottom-mode.png";
import topphone from "./img/phone-top-mode.png";
import contentphone from "./img/phone-content-mode.png";

class TemplateShowLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preview: 0
    };
  }
  renderDesktop(data) {
    return (
      <div>
        <StaticPage data={data} />
      </div>
    );
  }
  renderMobile(data) {
    return (
      <Flex className="preview-container" w={[1]} direction={["column"]}>
        <Flex w={["448px"]} justify={["center"]}>
          <BoxHeaderPhone w={[1]} />
        </Flex>
        <FlexMain w={["448px"]}>
          <FlexContent>
            <BoxContent w={["320px"]}>
              <StaticPage data={data} />
            </BoxContent>
          </FlexContent>
        </FlexMain>
        <BoxFooterPhone w={[1]} />
      </Flex>
    );
  }
  //{/* <iframe src={urlMobile} height={512} width={320} style={{border: 0}}/>  */}
  render() {
    const { content } = this.props.record;
    let data = undefined;
    if (!Array.isArray(content)) {
      data = content;
    }
    const { preview } = this.state;
    return (
      <div>
        {!data && (
          <DivEmpty>Content is Empty, Please create and save it </DivEmpty>
        )}
        {data && (
          <Box w={[1]}>
            <Flex w={[1]} p={[1]} align={["center"]} justify={["flex-end"]}>
              <FlatButton
                primary={preview === 1}
                secondary={preview === 0}
                onClick={() => this.setState({ preview: 0 })}
                label={"Desktop"}
                labelPosition={"after"}
                icon={<DestopIcon />}
              />
              <FlatButton
                primary={preview === 0}
                secondary={preview === 1}
                onClick={() => this.setState({ preview: 1 })}
                label={"Mobile"}
                labelPosition={"after"}
                icon={<MobileIcon />}
              />
            </Flex>
            {preview === 0 ? this.renderDesktop(data) : this.renderMobile(data)}
          </Box>
        )}
      </div>
    );
  }
}
TemplateShowLayout.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  record: PropTypes.object,
  resource: PropTypes.string,
  style: PropTypes.object
};

const DivEmpty = styled.div`
  background-color: rgba(222, 242, 250, 0.85);
  outline: 1px dashed #2faade;
  min-height: 100px;
  font-size: 13px;
  color: #2faade;
  text-align: center;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  &:hover {
    outline: 2px solid #7aabc0;
  }
`;

const BoxHeaderPhone = Box.extend`
  background-image: url(${topphone});
  background-repeat: no-repeat;
  background-size: contain;
  height: 72px;
`;
const BoxFooterPhone = Box.extend`
  background-image: url(${bottomphone});
  background-repeat: no-repeat;
  background-size: contain;
  height: 127px;
  width: 448px;
  justify-content: center;
`;

const FlexMain = Flex.extend`
  max-height: 512px;
  justify-content: center;
`;

const FlexContent = FlexMain.extend`
  background-image: url(${contentphone});
  background-repeat: repeat-y;
  background-size: contain;
  height: 100%;
  width: 100%;
`;

const BoxContent = FlexMain.extend`
  height: 100%;
  overflow-y: scroll;
`;

export default TemplateShowLayout;



// WEBPACK FOOTER //
// ./src/contents/TemplateShowLayout.js